import { render, staticRenderFns } from "./StudentArchive.vue?vue&type=template&id=7405912c&"
import script from "./StudentArchive.vue?vue&type=script&lang=ts&"
export * from "./StudentArchive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports